import { useState } from "react";
import { X, FlaskConical } from "lucide-react";

const BETA_BANNER_KEY = "mobile-beta-banner-dismissed";

export function MobileBetaBanner() {
  const [dismissed, setDismissed] = useState(
    () => sessionStorage.getItem(BETA_BANNER_KEY) === "1"
  );

  if (dismissed) return null;

  return (
    <div
      className="flex items-center gap-2 border-b border-border/40 px-4 py-2 text-sm"
      style={{ background: "hsl(var(--info-bg))", color: "hsl(var(--info-text))" }}
    >
      <FlaskConical className="h-4 w-4 shrink-0" />
      <span className="flex-1">Mobile view is currently in beta. Some features may be limited.</span>
      <button
        onClick={() => {
          sessionStorage.setItem(BETA_BANNER_KEY, "1");
          setDismissed(true);
        }}
        className="shrink-0 rounded p-0.5 hover:opacity-70 transition-opacity"
        aria-label="Dismiss beta notice"
      >
        <X className="h-4 w-4" />
      </button>
    </div>
  );
}
